export const isExcludeVideoElement = videoData => {
  const tagsArray = videoData?.taxonomy?.tags;
  return tagsArray?.some(tag => tag.text === "excludevideoelement");
};

import { generateGradient } from "../../common/utils";
import { BASE_URL } from "../globals";
import { PlayerSize } from "../orca/hooks/usePlayerSize";

export const getCanonicalUrl = video => {
  if (!video?.canonical_url) return null;

  return video.canonical_url.includes(BASE_URL)
    ? video.canonical_url
    : `${BASE_URL}${video.canonical_url}`;
};

export const getIsMiniPlayer = (playerSize, isFullscreen, isVertical) => {
  return playerSize === PlayerSize.MINI && !isFullscreen && !isVertical;
};

export const getControlsContainerHeight = () => {
  return window.innerHeight ? `${window.innerHeight}px` : "100%";
};

export const getGradient = (isLooping, isOpenSticky, isMiniPlayer) => {
  if (isLooping) {
    return {
      background: generateGradient({
        topPercent: 0,
        bottomPercent: 25
      })
    };
  }

  if (isOpenSticky || isMiniPlayer) {
    return {
      background: generateGradient({
        topPercent: 35,
        bottomPercent: 35
      })
    };
  }

  return {
    background: generateGradient({ topPercent: 15, bottomPercent: 25 })
  };
};
